export default "__VITE_ASSET__RU41dKtu__"